import { SchemaLoanRequestResolver_Get, SchemaLoanRequestResolver_GetSummary } from 'cpool-tables/backend-resolvers';
import { TFunction } from 'i18next';
import { LeadTraitsInfo, SchufaSource } from '~/types/LeadTraits';

import { getBucketInfo } from './getBucketInfo';
import { getKeyedInfo } from './getKeyedInfo';
import { getPartnerInfo } from './getPartnerInfo';
import { getRealEstateInfo } from './getRealEstateInfo';
import { getSchufaInfo } from './getSchufaInfo';

export const getSchufaTraits = (
    lead: SchemaLoanRequestResolver_GetSummary[number] | SchemaLoanRequestResolver_Get | null,
    schufaData: SchufaSource | null,
    t: TFunction<'de' | 'en', undefined>,
): LeadTraitsInfo => {
    if (!lead)
        return {
            bucket: null,
            keyed: null,
            partner: null,
            realEstate: null,
            schufa: null,
        };
    return {
        bucket: getBucketInfo(lead, t),
        keyed: getKeyedInfo(lead, t),
        partner: getPartnerInfo(lead, t),
        realEstate: getRealEstateInfo(lead, t),
        schufa: getSchufaInfo(lead, schufaData || null, t),
    };
};
